<div class="alerts">
    <ng-container *ngIf="isAlerts; else noAlertsBlock">
        <div class="alert-element" *ngFor="let alert of alerts">
            <div class="alert-status">
                <div class="rag-system-icon" [ngClass]="'rag-' + alert.level"></div>
            </div>
            <span *ngIf="!alert.url" class="alert-message">{{ alert.message }}</span>
            <a *ngIf="alert.url" class="alert-message" [routerLink]="[alert.url]">{{ alert.message }}</a>
        </div>
    </ng-container>
    <ng-template #noAlertsBlock>
        <div class="alerts-none">
            <ng-container *ngIf="isLoaded; else loadingAlertsBlock">
                <span>No Alerts</span>
            </ng-container>
            <ng-template #loadingAlertsBlock>
                <span>Loading</span>
            </ng-template>
        </div>
    </ng-template>
</div>